import React, { useMemo, useCallback, ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import FieldDate from '../field-date/field-date.component';
import DateService from '../../services/date-service';
import useStylesFilterDateField from './filter-date-field.styles';

const FilterDateField: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_PREFIX_FILTER_DATE_FIELD: string = 'filter-date-field';

  const {
    filterType,
    label,
    value,
    currentFilters,
    filterErrorMap,
    onSetFilterValue,
    onFilterError,
  } = props;

  const { classes } = useStylesFilterDateField();

  const filterFieldId: string = filterType ? `${ID_PREFIX_FILTER_DATE_FIELD}-${filterType}`
    : ID_PREFIX_FILTER_DATE_FIELD;

  const changeDeps: DepsItem[] = useMemo((): DepsItem[] => [currentFilters], [currentFilters]);
  const errorDeps: DepsItem[] = useMemo((): DepsItem[] => [filterErrorMap], [filterErrorMap]);

  const onChange: Function = useCallback((value: Date): void => {
    const formattedDate: string = DateService.formatDate(value) as string;

    if (onSetFilterValue) {
      onSetFilterValue(filterType, formattedDate || null);
    }
  }, [filterType, currentFilters]);

  const onError: Function = useCallback((error: string): void => {
    if (onFilterError) {
      onFilterError(filterType, error);
    }
  }, [filterType, filterErrorMap]);

  return (
    <FlexContainer isCentered className={classes.filterDateField}>
      <FieldDate
        isPlain
        isOutlined
        withBlankValues
        id={filterFieldId}
        value={value}
        label={label}
        labelClassName={classes.filterDateFieldLabel}
        changeDeps={changeDeps}
        errorDeps={errorDeps}
        onChange={onChange}
        onError={onError}
      />
    </FlexContainer>
  );
});

export default FilterDateField;
